/**
 * An agent's results per knowledge-base search, `config.kbTopK`: how many
 * matches one search gives the agent, its own searches and automatic search
 * alike. The scale is the agent function's (supabase/functions/_shared/agents/
 * config.ts, which refuses anything off it) — change both together.
 */

export const KB_TOP_K_DEFAULT = 3;
export const KB_TOP_K_MIN = 1;
export const KB_TOP_K_MAX = 5;

/** 1 … 5. */
const STEPS = Array.from({ length: KB_TOP_K_MAX }, (_, step) => step + 1);

/** The agent's stored value when it is on the scale; anything else (none, or no config at all)
 * is the default, as the bot reads it. */
export function kbTopKOf(config: object | null | undefined): number {
  const stored = config && "kbTopK" in config ? config.kbTopK : undefined;
  return STEPS.find((step) => step === stored) ?? KB_TOP_K_DEFAULT;
}
